import { createGlobalStyle } from "styled-components";

const GlobalPrintStyle = createGlobalStyle`
@page {
    size: A4 portrait;
    margin: 15mm 20mm 25mm 20mm; /* top right bottom left */

    /* Modern browsers */
    @bottom-right {
      content: "Page " counter(page, decimal-leading-zero);
      font-family: "Onest", sans-serif;
      font-size: 14px;
      font-weight: 500;
      color: #004f96;
      padding-bottom: 50mm; /* Extra space for page number */
      margin-bottom: 50mm; /* Extra space for page number */
    }
  }

  html {
    counter-reset: page;
  }

  @media print {
    /* ensure backgrounds/colors print */
    * {
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
    }

    /* remove scrollbars and force full visibility */
    html, body, #root {
      overflow: visible !important;
      height: auto !important;
    }

    /* drop shadows for printing */
    .no-print-shadow, .some‑wrapper-class {
      box-shadow: none !important;
    }

    /* hide anything you don’t want in print */
    .DigitalOnly, .no-print {
      display: none !important;
    }
    .PrintOnly {
      display: block !important;
    }
  }
`;

export default GlobalPrintStyle;
